<template>
  <div
    class="bothSidePlayer-performance"
    :class="[
      isPlayer ? '' : 'allCenter',
      homeInfor.playerInfos ? 'allCenter' : '',
    ]"
    v-if="datas.objectInfo && datas.objectInfo.length == 2"
  >
    <div class="img-box-left">
      <ab-country
        v-if="!isPlayer"
        :countryImg="homeInfor.countryImg"
        :countryName="homeInfor.countryName"
      ></ab-country>
      <template v-if="isPlayer">
        <span class="playersListTeam" v-if="homeInfor.playerInfos">
          <span class="playersList">
            <span
              class="playerName"
              v-for="player in homeInfor.playerInfos"
              :key="player.playerId"
              v-text="player.playerName"
            ></span>
          </span>
          <div class="country-box">
            <span class="country-boxSpan">
              <img :src="homeInfor.countryImg" alt="" />
            </span>
            <span class="country-name" v-text="homeInfor.countryName"></span>
          </div>
        </span>
        <AbPlayerImg
          v-else
          :playerImg="homeInfor.playerImg"
          :playerNum="homeInfor.playerNum"
          :playerName="`${homeInfor.playerName} ${
            homeInfor.position ? '(' + homeInfor.position + ')' : ''
          }`"
          :countryImg="homeInfor.countryImg"
          :countryName="homeInfor.countryName"
          :countryLogoSize="countryLogoSize"
        ></AbPlayerImg>
      </template>
    </div>
    <div class="items-box" v-if="lists && lists.length > 0">
      <div class="item" v-for="(item, index) in lists" :key="index">
        <div class="histogram-box">
          <ab-histogram
            :value="item.homeValue"
            :maxValue="item.maxValue"
            :textWidth="defaultValue1.textWidth"
            :position="defaultValue1.position"
            :mainColor="defaultValue1.mainColor"
            :barHeight="defaultValue1.barHeight"
            :suffix="item.suffix"
          ></ab-histogram>
        </div>
        <div class="text">
          {{ item.text }}
        </div>
        <div class="histogram-box">
          <ab-histogram
            :value="item.awayValue"
            :maxValue="item.maxValue"
            :textWidth="defaultValue2.textWidth"
            :position="defaultValue2.position"
            :mainColor="defaultValue2.mainColor"
            :barHeight="defaultValue2.barHeight"
            :suffix="item.suffix"
          ></ab-histogram>
        </div>
      </div>
    </div>
    <div class="img-box-right">
      <ab-country
        v-if="!isPlayer"
        :countryImg="awayInfor.countryImg"
        :countryName="awayInfor.countryName"
      ></ab-country>
      <template v-if="isPlayer">
        <span class="playersListTeam" v-if="awayInfor.playerInfos">
          <span class="playersList">
            <span
              class="playerName"
              v-for="player in awayInfor.playerInfos"
              :key="player.playerId"
              v-text="player.playerName"
            ></span>
          </span>
          <div class="country-box">
            <span class="country-boxSpan">
              <img :src="awayInfor.countryImg" alt="" />
            </span>
            <span class="country-name" v-text="awayInfor.countryName"></span>
          </div>
        </span>
        <AbPlayerImg
          v-else
          :playerImg="awayInfor.playerImg"
          :playerNum="awayInfor.playerNum * 1"
          :playerName="`${awayInfor.playerName} ${
            awayInfor.position ? '(' + awayInfor.position + ')' : ''
          }`"
          :countryImg="awayInfor.countryImg"
          :countryName="awayInfor.countryName"
          :countryLogoSize="countryLogoSize"
        ></AbPlayerImg>
      </template>
    </div>
  </div>
</template>

<script>
// 球员数据对比
import AbCountry from '../components/AbCountry.vue'
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
import AbHistogram from '../components/AbHistogram.vue'
export default {
  props: {
    // 必传参数，所有的数据
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isPlayer: {
      default: true,
    },
  },
  data() {
    return {
      defaultValue1: {
        textWidth: 2.083,
        position: 'right',
        barHeight: 0.556,
      },
      defaultValue2: {
        textWidth: 2.083,
        position: 'left',
        barHeight: 0.556,
      },
    }
  },
  created() {},
  components: {
    'ab-country': AbCountry,
    'ab-histogram': AbHistogram,
    AbPlayerImg: AbPlayerImg,
  },
  computed: {
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return ['1.666vw', '1.666vw']
      } else {
        return ['2.498vw', '1.666vw']
      }
    },
    homeInfor() {
      let homeInfor = {
        playerImg: '',
        playerNum: '',
        playerName: '',
        countryName: '',
        countryImg: '',
        position: '',
      }
      if (this.datas.objectInfo && this.datas.objectInfo[0]) {
        // const objectInfo = [
        //   {
        //     teamName: '中国',
        //     teamNameEn: '',
        //     teamId: 'CHN',
        //     teamLogo:
        //       'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
        //     teamScore: '',
        //     winFlag: '0',
        //     competitorId: null,
        //     playerInfos: [
        //       {
        //         playerName: '朱辰杰',
        //         playerNameEn: '',
        //         personNameEn: '',
        //         playerId: '2021746',
        //         profilePicture:
        //           'https://hyper-sports-res.mixtmt.com/players.png',
        //         position: '',
        //         shirtNumber: '',
        //         positionName: null,
        //         age: 23,
        //         height: 185,
        //         weight: 80,
        //       },
        //       {
        //         playerName: '朱辰杰1',
        //         playerNameEn: '',
        //         personNameEn: '',
        //         playerId: '20217461',
        //         profilePicture:
        //           'https://hyper-sports-res.mixtmt.com/players.png',
        //         position: '',
        //         shirtNumber: '',
        //         positionName: null,
        //         age: 23,
        //         height: 185,
        //         weight: 80,
        //       },
        //     ],
        //   },
        //   {
        //     teamName: '中国',
        //     teamNameEn: '',
        //     teamId: 'CHN',
        //     teamLogo:
        //       'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
        //     teamScore: '',
        //     winFlag: '0',
        //     competitorId: null,
        //     playerInfos: [
        //       {
        //         playerName: '朱辰杰',
        //         playerNameEn: '',
        //         personNameEn: '',
        //         playerId: '2021746',
        //         profilePicture:
        //           'https://hyper-sports-res.mixtmt.com/players.png',
        //         position: '',
        //         shirtNumber: '',
        //         positionName: null,
        //         age: 23,
        //         height: 185,
        //         weight: 80,
        //       },
        //     ],
        //   },
        // ]
        const teamInfor = this.datas.objectInfo[0]
        // const teamInfor = objectInfo[0]
        let playerInfos =
          teamInfor.playerInfos && teamInfor.playerInfos.length > 0
            ? teamInfor.playerInfos
            : null
        let playerInfor = null
        if (playerInfos && playerInfos.length === 1) {
          playerInfor = playerInfos[0]
          homeInfor = {
            playerImg: playerInfor.profilePicture,
            playerNum: playerInfor.shirtNumber,
            playerName: playerInfor.playerName,
            countryName: teamInfor.teamName,
            countryImg: teamInfor.teamLogo,
            position: playerInfor.position,
          }
        } else if (playerInfos && playerInfos.length > 1) {
          homeInfor = {
            countryName: teamInfor.teamName,
            countryImg: teamInfor.teamLogo,
            playerInfos: playerInfos,
          }
        } else if (!playerInfos || playerInfos.length === 0) {
          homeInfor = {
            countryName: teamInfor.teamName,
            countryImg: teamInfor.teamLogo,
          }
        }
      }
      console.debug('homeInfor:', homeInfor)
      return homeInfor
    },
    awayInfor() {
      // const objectInfo = [
      //   {
      //     teamName: '中国',
      //     teamNameEn: '',
      //     teamId: 'CHN',
      //     teamLogo:
      //       'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
      //     teamScore: '',
      //     winFlag: '0',
      //     competitorId: null,
      //     playerInfos: [
      //       {
      //         playerName: '朱辰杰',
      //         playerNameEn: '',
      //         personNameEn: '',
      //         playerId: '2021746',
      //         profilePicture: 'https://hyper-sports-res.mixtmt.com/players.png',
      //         position: '',
      //         shirtNumber: '',
      //         positionName: null,
      //         age: 23,
      //         height: 185,
      //         weight: 80,
      //       },
      //       {
      //         playerName: '朱辰杰1',
      //         playerNameEn: '',
      //         personNameEn: '',
      //         playerId: '20217461',
      //         profilePicture: 'https://hyper-sports-res.mixtmt.com/players.png',
      //         position: '',
      //         shirtNumber: '',
      //         positionName: null,
      //         age: 23,
      //         height: 185,
      //         weight: 80,
      //       },
      //     ],
      //   },
      //   {
      //     teamName: '中国',
      //     teamNameEn: '',
      //     teamId: 'CHN',
      //     teamLogo:
      //       'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
      //     teamScore: '',
      //     winFlag: '0',
      //     competitorId: null,
      //     playerInfos: [
      //       {
      //         playerName: '朱辰杰',
      //         playerNameEn: '',
      //         personNameEn: '',
      //         playerId: '2021746',
      //         profilePicture: 'https://hyper-sports-res.mixtmt.com/players.png',
      //         position: '',
      //         shirtNumber: '',
      //         positionName: null,
      //         age: 23,
      //         height: 185,
      //         weight: 80,
      //       },
      //       {
      //         playerName: '朱辰杰2',
      //         playerNameEn: '',
      //         personNameEn: '',
      //         playerId: '20217462',
      //         profilePicture: 'https://hyper-sports-res.mixtmt.com/players.png',
      //         position: '',
      //         shirtNumber: '',
      //         positionName: null,
      //         age: 23,
      //         height: 185,
      //         weight: 80,
      //       },
      //     ],
      //   },
      // ]
      let awayInfor = {
        playerImg: '',
        playerNum: '',
        playerName: '',
        countryName: '',
        countryImg: '',
        position: '',
      }
      if (this.datas.objectInfo && this.datas.objectInfo[1]) {
        const teamInfor = this.datas.objectInfo[1]
        // const teamInfor = objectInfo[1]
        let playerInfos =
          teamInfor.playerInfos && teamInfor.playerInfos.length > 0
            ? teamInfor.playerInfos
            : null
        let playerInfor = null
        if (playerInfos && playerInfos.length === 1) {
          playerInfor = playerInfos[0]
          awayInfor = {
            playerImg: playerInfor.profilePicture,
            playerNum: playerInfor.shirtNumber,
            playerName: playerInfor.playerName,
            countryName: teamInfor.teamName,
            countryImg: teamInfor.teamLogo,
            position: playerInfor.position,
          }
        } else if (playerInfos && playerInfos.length > 1) {
          awayInfor = {
            countryName: teamInfor.teamName,
            countryImg: teamInfor.teamLogo,
            playerInfos: playerInfos,
          }
        } else if (!playerInfos || playerInfos.length === 0) {
          awayInfor = {
            countryName: teamInfor.teamName,
            countryImg: teamInfor.teamLogo,
          }
        }
      }
      return awayInfor
    },
    lists() {
      if (this.datas.data.dataList && this.datas.data.dataList.length == 2) {
        const home = this.datas.data.dataList[0]
        const away = this.datas.data.dataList[1]
        const max = this.datas.data.maxDataList[0]
        return this.datas.statisticsModels.map((modeItem) => {
          const homeValue = home[modeItem.statisticalEn]
          const awayValue = away[modeItem.statisticalEn]
          const maxValue = max[modeItem.statisticalEn]
          // console.debug(
          //   home,
          //   modeItem.statisticalEn,
          //   home[modeItem.statisticalEn]
          // )
          return {
            maxValue,
            homeValue,
            awayValue,
            text: modeItem.name,
            suffix: modeItem.suffix,
          }
        })
      }
      return []
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text} ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.bothSidePlayer-performance {
  /* margin: 0 auto; */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  &.allCenter {
    align-items: center;
  }
  .img-box-left,
  .img-box-right {
    .playersListTeam {
      width: 7.64vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .playersList {
        padding: 1.11vw 0;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .playerName {
          width: 100%;
          font-size: 0.972vw;
          line-height: 2.083vw;
          color: var(--mixtmt_greyColor2);
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
    .country-box {
      position: relative;
      height: 1.666vw;
      text-align: center;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;

      .country-boxSpan {
        position: relative;
        width: 1.8vw;
        height: 1.2vw;
        margin-right: 0.694vw;
        &::before {
          content: '\20';
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .country-name {
        font-size: 0.972vw;
        color: var(--mixtmt_greyColor_main);
        line-height: 1.666vw;
        vertical-align: top;
      }
    }
  }
  .items-box {
    width: 100%;
    .item {
      font-size: 0;
      line-height: 1.25vw;
      .histogram-box {
        display: inline-block;
        width: 6.94vw;
      }
      .text {
        display: inline-block;
        font-size: 0.833vw;
        color: var(--mixtmt_greyColor_main);
        width: 6.25vw;
        /* margin: 0 0.32vw; */
        text-align: center;
        vertical-align: middle;
      }
    }
  }
  /* .img-box-right {
  } */
}
</style>
